import type { ReactNode } from "react";
import clsx from "clsx";
import {
  presentActionLogEntry,
  type ActionLogDocumentKind,
} from "@/features/timesheetFlow/actionLogDisplay";
import type { ActionLogEntry } from "@/features/timesheetFlow/timesheetFlowApi";

function fmtDateTimeDe(iso: string | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString("de-DE");
}

function LogCard({
  badge,
  badgeClass,
  when,
  children,
  who,
}: {
  badge: string;
  badgeClass: string;
  when: string;
  children: ReactNode;
  who: string;
}) {
  return (
    <li className="rounded-ios border border-separator bg-card-elevated p-3 text-sm">
      <div className="mb-1 flex flex-wrap items-center gap-2">
        <span className={clsx("rounded-full px-2 py-0.5 text-[11px] font-medium", badgeClass)}>
          {badge}
        </span>
        <strong className="text-label">{when}</strong>
      </div>
      <div className="space-y-0.5 text-label-secondary">{children}</div>
      <div className="mt-1 text-xs text-label-tertiary">Von: {who}</div>
    </li>
  );
}

export function TimesheetActionLogList({
  entries,
  timesheetLabel,
  documentKind = "stundennachweis",
}: {
  entries: ActionLogEntry[];
  timesheetLabel?: string;
  documentKind?: ActionLogDocumentKind;
}) {
  if (!entries.length) {
    return <p className="text-sm text-label-secondary">Noch keine Einträge vorhanden.</p>;
  }

  return (
    <ul className="max-h-[min(50vh,28rem)] space-y-2 overflow-y-auto pr-1">
      {entries.map((entry, index) => {
        const view = presentActionLogEntry(entry, {
          kind: documentKind,
          number: timesheetLabel,
        });
        return (
          <LogCard
            key={entry.id ?? index}
            badge={view.badge}
            badgeClass={view.badgeClass}
            when={fmtDateTimeDe(entry.created_at)}
            who={view.who}
          >
            {view.lines.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </LogCard>
        );
      })}
    </ul>
  );
}
